import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './HomePage.scss';
import image1 from '../assets/image1.jpg';
import image2 from '../assets/image2.jpeg';
import image3 from '../assets/image3.jpg';
import image4 from '../assets/image4.jpeg';

const HomePage = () => {
    const images = [image1, image2, image3, image4];
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [fade, setFade] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            setFade(true);
            setTimeout(() => {
                setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
                setFade(false);
            }, 400); // Half of transition duration
        }, 5000); // Change image every 5 seconds

        return () => clearInterval(interval);
    }, [images.length]);

    return (
        <div className="home-container">
            {/* Hero Section */}
            <section className="hero" id="home">
                <div className="hero-container">
                    <div className="hero-content">
                        <h1>Welcome to CHAIropractic</h1>
                        <p>At CHAIropractic, we specialize in advanced treatments for pain relief,
                        mobility enhancement, and performance improvement for all ages, 
                        ensuring personalized care for every visit.</p>
                        <div className="hero-buttons">
                            <Link to="/contact" className="btn-primary">Schedule Consultation</Link>
                            <Link to="/services" className="btn-secondary">Learn More</Link>
                        </div>
                    </div>
                    <div className="hero-image">
                        <div className="image-wrapper">
                            <img 
                                src={images[currentImageIndex]} 
                                alt="CHAIropractic Treatment" 
                                className={fade ? 'fade-out' : 'fade-in'}
                            />
                        </div>
                    </div>
                </div>
            </section>

            {/* Stats Section */}
            <section className="stats">
                <div className="stats-container">
                    <div className="stat-card">
                        <div className="stat-number">5.0</div>
                        <div className="stat-label">Google Review</div>
                    </div>
                    <div className="stat-card">
                        <div className="stat-number">30 - 45 mins</div>
                        <div className="stat-label">Focused Sessions</div>
                    </div>
                    <div className="stat-card">
                        <div className="stat-number">100%</div>
                        <div className="stat-label">Personalized Care</div>
                    </div>
                </div>
            </section>

            {/* Services Section */}
            <section className="services" id="services">
                <div className="section-header">
                    <h2>Our Specialized Services</h2>
                    <p>Comprehensive Care Tailored to Your Unique Needs</p>
                </div>
                <div className="services-grid">
                    <div className="service-card">
                        <div className="service-icon">💆</div>
                        <h3>COX® Flexion Distraction Technic</h3>
                    </div>
                    <div className="service-card">
                        <div className="service-icon">🏃</div>
                        <h3>Diversified Chiropractic Adjustment</h3>
                    </div>
                    <div className="service-card">
                        <div className="service-icon">⚡</div>
                        <h3>Erchonia® Percussor</h3>
                    </div>
                    <div className="service-card">
                        <div className="service-icon">👨‍👩‍👧‍👦</div>
                        <h3>Erchonia® Cold Laser</h3>
                    </div>
                    <div className="service-card">
                        <div className="service-icon">🎯</div>
                        <h3>Chattanooga Intelect Electrotherapy</h3>
                    </div>
                    <div className="service-card">
                        <div className="service-icon">🌟</div>
                        <h3>Chattanooga Intelect Ultrasound</h3>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="cta-section" id="contact">
                <div className="phone-number">(949) 371-9377</div>
                <Link to="/contact" className="btn-primary">Call Now</Link>
            </section>
        </div>
    );
};

export default HomePage;

